// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();

document.addEventListener('DOMContentLoaded', function() {
    const accordions = document.querySelectorAll('.accordion');

    accordions.forEach(function(accordion) {
        accordion.addEventListener('click', function() {
            const panel = this.parentElement.parentElement.nextElementSibling;
            if (panel.style.display === 'table-row') {
                panel.style.display = 'none';
                this.textContent = 'Expandir';
            } else {
                panel.style.display = 'table-row';
                this.textContent = 'Minimizar';
            }
        });
    });
});


document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a.btn-canvas-link').forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            var href = this.href;
            var target = this.target;

            fetch(window.woocommerce_params.ajax_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: 'canvas_remove_user_suspension',
                }),
            })
            .then(function () {
                if (target === '_blank') {
                    window.open(href, target);
                } else {
                    window.location.href = href;
                }
            })
            .catch(function (error) {
                console.error('Erro no AJAX:', error);
            });
        });
    });
});